import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "./pages/Dashboard";
import Sources from "./pages/Sources";
import Articles from "./pages/Articles";
import Monitoring from "./pages/Monitoring";
import Settings from "./pages/Settings";
import Logs from "./pages/Logs";
import { Activity, FileText, Globe, Settings as SettingsIcon, BarChart3, Radio } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function Navigation() {
  const location = useLocation();
  
  const navItems = [
    { path: "/", label: "Tableau de bord", icon: BarChart3 },
    { path: "/sources", label: "Sources", icon: Globe },
    { path: "/monitoring", label: "Veille", icon: Radio },
    { path: "/articles", label: "Articles", icon: FileText },
    { path: "/logs", label: "Logs", icon: Activity },
    { path: "/settings", label: "Paramètres", icon: SettingsIcon },
  ];
  
  return (
    <nav className="bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Logo" 
                className="h-12 w-auto"
              />
            </Link>
            
            <div className="hidden md:flex space-x-1">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-link flex items-center space-x-2 px-4 py-2 rounded-lg ${isActive ? 'active' : ''}`}
                    data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                  >
                    <Icon size={18} />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <div className="app-container">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Navigation />
        <div className="max-w-7xl mx-auto px-6 py-8">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/sources" element={<Sources />} />
            <Route path="/monitoring" element={<Monitoring />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
